import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixLoyaltyTransactionV1LoyaltyTransactionsUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'api._api_base_domain_': [
      {
        srcPath: '/loyalty-transactions',
        destPath: '',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/loyalty-transactions',
        destPath: '',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/loyalty-transactions',
        destPath: '',
      },
    ],
    _: [
      {
        srcPath: '/_api/loyalty-transactions',
        destPath: '',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/loyalty-transactions',
        destPath: '',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_loyalty_transactions';

/** Retrieves a transaction. */
export function getLoyaltyTransaction(
  payload: object
): RequestOptionsFactory<any> {
  function __getLoyaltyTransaction({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.loyalty.transaction.v1.loyalty_transaction',
      method: 'GET' as any,
      methodFqn:
        'wix.loyalty.transaction.v1.LoyaltyTransactions.GetLoyaltyTransaction',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixLoyaltyTransactionV1LoyaltyTransactionsUrl({
        protoPath: '/v1/loyalty-transactions/{loyaltyTransactionId}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [{ path: 'loyaltyTransaction.createdDate' }],
          },
        ]),
    };

    return metadata;
  }

  return __getLoyaltyTransaction;
}

/**
 * Retrieves a list of loyalty transactions with the specified paging, filtering, and sorting.
 *
 * To learn about working with _Query_ methods, see [API Query Language](https://dev.wix.com/docs/rest/articles/get-started/api-query-language),
 * [Sorting and Paging](https://dev.wix.com/docs/rest/articles/get-started/sorting-and-paging),
 * and [Field Projection](https://dev.wix.com/docs/rest/articles/get-started/field-projection).
 */
export function queryLoyaltyTransactions(
  payload: object
): RequestOptionsFactory<any> {
  function __queryLoyaltyTransactions({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.loyalty.transaction.v1.loyalty_transaction',
      method: 'POST' as any,
      methodFqn:
        'wix.loyalty.transaction.v1.LoyaltyTransactions.QueryLoyaltyTransactions',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixLoyaltyTransactionV1LoyaltyTransactionsUrl({
        protoPath: '/v1/loyalty-transactions/query',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [{ path: 'loyaltyTransactions.createdDate' }],
          },
        ]),
    };

    return metadata;
  }

  return __queryLoyaltyTransactions;
}
